import React from "react";
import localeText from "../../../locale";

const ConfimeaConfirmationHeader = () => {
  return (
    <div className="confimea-confirmation-header">
      <div className="flex align-items-center gap-3 justify-content-center mb-2">
        <i className="pi pi-check-circle text-white text-4xl"></i>
        <div className="confimea-confirmation-title title">{localeText("emailVerified")}</div>
      </div>
      <p className="confimea-confirmation-subtitle">
        {localeText("completeActivationSubtitle")}
      </p>
    </div>
  );
};

export default ConfimeaConfirmationHeader;

